import {
  isEmployeeActingAsCustomerSession,
  useImpersonationSession,
} from '../impersonation-session';

/**
 * True whenever a Highlight employee is acting as a customer — Better Auth
 * impersonation and admin-scoped sessions alike. Drives the IMPERSONATING
 * banner, so both entry paths look the same on every portal page.
 */
const useGetIsImpersonating = () => {
  const session = useImpersonationSession();

  return isEmployeeActingAsCustomerSession(session);
};

export default useGetIsImpersonating;
